import React, { Component } from 'react'
import '../css/addConfig.css';


export default class AddConfig extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const classNames = ['add-package', this.props.className? this.props.className: ''].join(' ')
    return (
      <div className={classNames} onClick={this.props.onClick}>
        <img src='images/add-circle.svg' />
        {this.props.buttonText && <p>{this.props.buttonText}</p>}
      </div>
    )
  }
}
